import { render, staticRenderFns } from "./MarketCartTableVariantPrice.vue?vue&type=template&id=3e20a07e&"
import script from "./MarketCartTableVariantPrice.vue?vue&type=script&lang=js&"
export * from "./MarketCartTableVariantPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports